export const blakeProfileData = {
  personal: {
    name: "Blake Carter",
    title: "Technical Leader",
    email: "blake@drksci.com",
    phone: "Available on request",
    location: "Brisbane, QLD",
    linkedIn: "https://www.linkedin.com/in/blake-carter-5995ab5a/",
    portfolio: "https://drksci.com",
    availability: "Immediate"
  },
  
  summary: "Hands-on technical leader with organic experience spanning product development, operational excellence, and strategic transformation. Passionate about tackling complex challenges that require deep understanding and versatile execution.",
  
  focusAreas: "Focused on opportunities with natural fit to experience, tenacity, and disposition to look beyond the status-quo. Thrives on novel challenges, hands-on learning, jumping in the deep end.",
  
  philosophy: [
    {
      icon: "eye",
      title: "Envision",
      subtitle: "the extraordinary"
    },
    {
      icon: "collaborate", 
      title: "Collaborate",
      subtitle: "with charisma"
    },
    {
      icon: "persevere",
      title: "Persevere", 
      subtitle: "to achieve"
    }
  ],
  
  character: [
    "Thrives on novel challenges, hands-on learning, jumping in the deep end",
    "Pursues meaningful work with passion for ground-up understanding, rather than position descriptions", 
    "Values meaningful stakeholder relationships and dependability as essential foundations"
  ],
  
  insights: {
    "Location": "Brisbane",
    "Travel": "Willing", 
    "Married": "Las Vegas",
    "Hobby": "Spelunking",
    "First car": "'91 Prelude",
    "First PC": "Osbourne 1", 
    "Holiday": "Waratah, TAS",
    "Weakness": "Challenges"
  },
  
  experience: [
    {
      title: "Founder",
      company: "Drksci",
      period: "Aug 2024 - Present",
      tags: "Innovation Lab • AI Integration • Data Visualisation • Rapid Prototyping • Machine Learning • Artificial Intelligence • Business Intelligence • Product Development • Startup Founder • Technology Strategy",
      description: "Founded d/rksci as an innovation laboratory exploring the intersection of AI, data science, and practical business applications. Specialised in rapidly prototyping novel solutions and transforming ambitious concepts into market-ready realities.",
      projects: [
        {
          name: "rained.cloud",
          url: "/portfolio/rained-cloud",
          color: "cyan",
          description: "Historical rainfall data preservation platform (100+ years of weather data)"
        },
        {
          name: "Kareer.app", 
          url: "/portfolio/kareer",
          color: "purple",
          description: "Career development platform with AI-driven insights and personalised guidance"
        }
      ],
      research: [
        {
          name: "MapGyver",
          url: "/research/mapgyver-lost-person-modeling", 
          color: "green",
          description: "AI-powered lost person modelling using terrain analysis and behavioural prediction"
        },
        {
          name: "Prophet",
          url: "/research/prophet-experiment",
          color: "orange", 
          description: "Experimental AI consciousness exploration and pattern recognition"
        },
        {
          name: "Princhester Associates",
          url: "/research/princhester-associates",
          color: "pink",
          description: "AI-powered consulting and strategic advisory platform"
        }
      ]
    },
    {
      title: "Chief Executive Officer",
      company: "ValuePRO Software",
      period: "Jan 2022 - Aug 2024 (2 yrs 8 mos)", 
      tags: "Constellation Software Portfolio • PropTech • Platform Modernisation • Executive Leadership • CEO • Software Engineering • Product Strategy • Digital Transformation • Team Management • P&L Management • EBITA • eNPS • Agile Management",
      description: "Revitalised ValuePRO's product portfolio and positioned the company as the premier PropTech solutions partner for the valuation industry following acquisition by Constellation Software. Led modernisation of highly customised product portfolio including 40+ customised (250k+ LOC) forks of mission-critical software in complex private cloud environment.",
      accomplishments: [
        "Replatformed and launched alpha successor to legacy (450k+ LOC) core product in under 1 year",
        "Achieved eNPS of 8.5–9.5 by shifting team culture to embrace meaningful impacts", 
        "Consistent 40-50% EBITA margin and eNPS of 8.5-9.5/10"
      ]
    },
    {
      title: "Operations Manager", 
      company: "ValuePRO Software",
      period: "Jan 2017 - Jan 2022 (5 yrs 1 mo)",
      tags: "Team Leadership • Compliance • Security • Professional Services • ISO27001 • ISO9001 • Operations Management • SIEM • EDR • Information Security • Risk Management • Quality Assurance",
      description: "Led development teams in building scalable web applications while maintaining corporate governance and compliance standards across ISO27001 and 9001 certifications.",
      accomplishments: [
        "Maintained ISO27001 & 9001 certification with zero audit findings",
        "Implemented SIEM and EDR security solutions across enterprise infrastructure"
      ]
    },
    {
      title: "Senior Software Architect",
      company: "ValuePRO Software", 
      period: "Apr 2016 - Jan 2017 (10 mos)",
      tags: "Legacy Modernisation • DevOps • Source Control • Platform Architecture • CI/CD • Git • Software Architecture • System Integration • Change Management • Enterprise Software • Technical Leadership",
      description: "Joined ValuePRO to spearhead platform modernisation and establish foundational systems including CRM, SOPs, source control, and DevOps practices. Evolved role to encompass BAU operations, systems management, offshore team leadership, and key account stewardship.",
      accomplishments: [
        "Implemented CI/CD pipelines and change management procedures",
        "Managed 100:2 consolidation of divergent internal dependency codebases", 
        "Introduced source control for 150+ legacy codebases"
      ]
    },
    {
      title: "Earlier Career",
      company: "Various Ventures", 
      period: "2003 - 2019",
      tags: "Entrepreneurial Ventures • Technology Innovation • Platform Development • Azure • SaaS Architecture • GIS • AgTech • Blockchain • Bitcoin • Fintech • VPS Hosting • Cloud Computing • Software Engineering",
      description: "",
      accomplishments: [
        "Lead Software Engineer, Jetval (2018-19) — Azure SaaS architecture",
        "GIS Consultant, Proprietor (2016) — AgTech data analysis",
        "Co-Founder, Hashfund Limited (2013-15) — Bitcoin exchange platform", 
        "Director, Maintainable Pty Ltd (2011-12) — Property services integration",
        "Operations Manager, P2P Advertising Network (2008-11) — Distributed advertising",
        "Co-Founder, Alpha BHO (2008-09) — Browser advertising network",
        "Co-Founder, Auxhosting (2006-07) — VPS hosting provider", 
        "Software Engineer, Proprietor (2003-05) — Freelance development"
      ]
    }
  ],
  
  skills: {
    "LEADERSHIP": "P&L • Strategy • Talent • Executive Management • Team Building • Change Management",
    "TECHNICAL": "DevOps • Cloud • Security • Software Architecture • CI/CD • Git • Azure • AWS • Docker • Kubernetes • Python • JavaScript • React • Node.js • Database Design • API Development",
    "OPERATIONS": "Process • Compliance • Scale • ISO27001 • ISO9001 • SIEM • EDR • Risk Management • Quality Assurance • Vendor Management",
    "INNOVATION": "AI • Research • Prototyping • Machine Learning • Data Science • Product Development • Digital Transformation • Startup Operations"
  },
  
  education: {
    "APPROACH": "Self-directed • Reverse engineering",
    "METHODOLOGY": "Scaling Up • Peer learning",
    "FORMAL": "B.A. / B.IT. - UQ (skipped)", 
    "PROGRAMMING": "Self-taught (2006 - present)"
  }
};